import { Button } from "@/components/button/Button"
import { Warning } from "@/components/icons/Warning"
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import { formatTimeDelta } from "@/lib/formatTimeDelta"
import { TenantFeature } from "@/store/tenant"
import { ColumnDef } from "@tanstack/react-table"
import { Task, TaskStatus } from "src/types"
import { Link } from "wouter"

export const createColumns = (
  onConfirmTask: (
    e: React.MouseEvent<HTMLButtonElement>,
    taskId: number,

    status: TaskStatus,
  ) => void,
): ColumnDef<Task>[] => {
  return [
    {
      accessorKey: "workerName",
      header: "Darbinieks",
      cell: ({ row }) => {
        const og = row.original
        const created = og.createdAt
          ? new Intl.DateTimeFormat("lv", {
              dateStyle: "short",
              timeStyle: "short",
            }).format(new Date(og.createdAt))
          : "-"

        return (
          <>
            <div>{og.workerName}</div>
            <div className="text-[var(--text-secondary)] text-sm">
              {created}
            </div>
          </>
        )
      },
    },
    {
      accessorKey: "projectName",
      header: "Sērija",
      cell: ({ row }) => {
        const og = row.original
        return (
          <span className="flex items-center gap-2">
            <Link to={`/../projects/${og.projectId}/${og.subProjectId}`}>
              {og.projectName} / {og.subProjectName} / {og.operationName}
            </Link>
          </span>
        )
      },
    },
    {
      accessorKey: "id",
      header: "Tips",
      cell: ({ row }) => {
        const og = row.original
        if (
          og.status === TaskStatus.Error ||
          og.status === TaskStatus.ErrorAck
        ) {
          return (
            <span className="flex items-center gap-2">
              <Warning width={13} height={12} />
              Reģistrēts defekts
            </span>
          )
        }
        return "Kļūdas labojums"
      },
    },
    {
      accessorKey: "date",
      header: "Datums",
    },
    {
      accessorKey: "comment",
      header: "Piezīmes",
      cell: ({ row }) => {
        const og = row.original
        return og.comment ? (
          <TooltipProvider delayDuration={100}>
            <Tooltip>
              <TooltipTrigger>
                <span className="block max-w-[100px] overflow-hidden text-ellipsis whitespace-nowrap">
                  {og.comment}
                </span>
              </TooltipTrigger>
              <TooltipContent>{og.comment}</TooltipContent>
            </Tooltip>
          </TooltipProvider>
        ) : (
          "-"
        )
      },
    },
    {
      accessorKey: "target",
      header: "Nosūtīt uz",
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row }) => {
        const og = row.original
        if (
          og.status === TaskStatus.Approved ||
          og.status === TaskStatus.ErrorAck
        ) {
          return "Apstiprināts"
        }
        return (
          <Button onClick={(e) => onConfirmTask(e, og.id, og.status)}>
            Apstiprināt
          </Button>
        )
      },
    },
  ]
}
